export default "__VITE_ASSET__BYkk0MvV__"